<template>
  <div class="mb-4 bg-white p-2 shadow-sm rounded" style="cursor: pointer;">
    <div 
      class="img-frame bg-light rounded d-flex align-items-center justify-content-center mb-2"
      style="height: 300px; overflow: hidden; position: relative;"
    >
      <b-img
        :src="src"
        fluid
        :alt="title"
        @click="$emit('preview', previewItem ? previewItem : src)"
        :style="imageStyles"
      ></b-img>
    </div>

    <div class="d-flex justify-content-between mt-2 align-items-center">
      <span class="font-weight-bold">{{ title || 'Foto' }}</span>
      
      <b-button size="sm" variant="pgiBtn" @click.stop="rotateImage">
        <i class="fa fa-repeat"></i>
      </b-button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ImageCard',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    previewItem: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      currentRotation: 0 
    };
  },
  computed: {
    imageStyles() {
      const isVertical = this.currentRotation % 180 !== 0;
      
      return {
        transform: `rotate(${this.currentRotation}deg)`,
        transition: '0.3s',
        objectFit: 'contain', 
        maxHeight: '100%',
        maxWidth: isVertical ? '300px' : '100%' 
      };
    }
  },
  methods: {
    rotateImage() {
      this.currentRotation += 90;
    }
  },
  watch: {
    src() {
      this.currentRotation = 0;
    }
  }
}
</script>